import { render, staticRenderFns } from "./ListRequestLetterSodorEsterdad.vue?vue&type=template&id=2b697117&scoped=true&"
import script from "./ListRequestLetterSodorEsterdad.vue?vue&type=script&lang=js&"
export * from "./ListRequestLetterSodorEsterdad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b697117",
  null
  
)

export default component.exports